import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import CheckBoxOutlineBlankTwoToneIcon from '@material-ui/icons/CheckBoxOutlineBlankTwoTone';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';

import SurveyQuestionContext from '../../../context/surveyquestion-context';
import useStyles from "../../../styles/components/survey/stylesSurveyQuestionContainer";


const OpenEndedQuestionHolder = ({ index }) => {
    const classes = useStyles();
    const { surveyQuestionContext, dispatch } = useContext(SurveyQuestionContext);
    const position = index - (surveyQuestionContext.scaleContents.length + surveyQuestionContext.multipleChoiceContents.length + surveyQuestionContext.rankingContents.length + surveyQuestionContext.checkboxContents.length)

    const handleChange = (event) => {
        if (event.target.value.length <= 50) {
            surveyQuestionContext.freeText[position].input = event.target.value;
            dispatch({ type: 'SET_FREETEXT', freeText: surveyQuestionContext.freeText });
        }
        else {
            alert("Max 50 characters is allowed!");
        }
    };

    return (
        <div>
            {surveyQuestionContext.freeText.length > 0 &&
                <>
                    <Typography variant='h6' className={clsx(classes.rootTypographyQuestion, classes.typographyDown)}>{surveyQuestionContext.freeText[position].title}</Typography>
                    <Grid item xs={12} sm={12}>
                            <TextField
                                fullWidth={true}
                                id="outlined-name"
                                placeholder="Please write your answer(Max 50 characters) here... "
                                multiline={true}
                                rows={1}
                                value={surveyQuestionContext.freeText[position].input}
                                onChange={handleChange}
                                variant="outlined"
                            />
                    </Grid>
                </>
            }
        </div >
    )
}

export default OpenEndedQuestionHolder;